import {DOCUMENT} from '@angular/common';
import {HttpErrorResponse} from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfigurationService, LocaleService, Popr2Level, Popr2Priority, Popr2Service} from '@ciam/library';
import {Observable, Subject} from 'rxjs';
import {defaultIfEmpty, filter, finalize, switchMap, takeUntil} from 'rxjs/operators';
import {MFAPreferencesService} from 'src/app/services/mfaPreferences/mfaPreferences.service';
import {MFAPreferencesResponse} from 'src/app/shared/models/MFAPreferencesResponse';
import {GdlService} from 'src/app/shared/services/gdl-service/gdl.service';
import {WindowRef} from 'src/app/util/window.ref';
import {PoprPriority} from '../../../shared/components/popr/popr-priority.enum';
import {PoprService} from '../../../shared/components/popr/popr.service';
import {TwoFactorComponent} from '../../../shared/components/two-factor/two-factor.component';
import {FormElementConfig} from '../../../shared/models/FormElementConfig';
import {APIResponse, PhoneNumberDetails} from '../../../shared/models/LoginInfoResponse';
import {DeliveryChannelPreferences} from '../../../shared/models/MFAPreferencesResponse';
import {SessionStorageService} from '../../../shared/services/sessionStorage-service/session-storage.service';
import {SharedService} from '../../../shared/services/shared-service/shared.service';
import {TranslateService} from '@ngx-translate/core';

export enum PARAMS {
  MOCK = 'mock',
  DEFAULT_DELIVERY_METHOD = 'deliverymethod'
}

@Component({
  selector: 'wpro-adaptive-mfa',
  templateUrl: './adaptive-mfa.component.html',
  standalone: false
})
export class AdaptiveMfaComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly ERROR_CODE_400 = 400;
  private readonly destroy$ = new Subject<void>();
  gdlServerType = 'server';
  gdlContextPutType = 'PUT';
  gdlContextGetType = 'GET';
  gdlMfaLogin = '2fa-login';
  gdlMfaSwitchOn = 'ON';
  gdlMfaSwitchOff = 'OFF';
  gdlModal = 'modal';
  gdlOpen ='open';
  gdlClose ='dismiss';
  termsAndConditionUrl: string;
  twoStepVerifyForm: UntypedFormGroup;
  textMsgDropdownControl: UntypedFormControl;
  phoneCallDropdownControl: UntypedFormControl;
  contactDetails: DeliveryChannelPreferences[];
  phoneCode = '';
  primaryPhoneNumber: string;
  secondaryPhoneNumber: string;
  textMsgNumberSelected = '';
  phoneCallNumberSelected = '';
  textDropdownConfig: FormElementConfig;
  phoneDropdownConfig: FormElementConfig;
  @Input() twosvFlag: boolean;
  @Output() hideDefaultverifyandTrustedDevice= new EventEmitter<boolean>();
  @Output() hideSuccessNotificationPopup = new EventEmitter<boolean>();
  @Output() hideNotificationPopup = new EventEmitter<any>();
  @Output() closeLoginEdit = new EventEmitter<boolean>();
  @Output() continueVerifyFlow = new EventEmitter<boolean>();
  defaultMfaOnLogin = false;
  isAPIFailLoginScreen = false;
  showPopUp = false;
  deliveryType = '';
  deliveryTypeOld: string;
  gdlDeliveryType = '';
  twoStepVerificationClicked = false;
  mfaFlag = false;
  defaultDeliveryMethod: DeliveryChannelPreferences[];
  contactlinckclicked: boolean;
  /* Todo: Revisit once @Input is added to the Two-Factor component */
  isTwoStepVerification: boolean;
  //B-999556 update secondry phone number prefecence for MFA
  isPhoneNumLoading = false;
  textMsgSelectedLabel = '';
  phoneCallSelectedLabel = '';
  isTwoSVToggleLoading = true;
  deliveryMethod: string;

  @ViewChild('twoFactorElevationFailure', { read: TemplateRef })
  twoFactorFailureTemplate!: TemplateRef<any>;
  personalEmail: any;
  countryCode: string;
  isTwoFAEnabled=false;
  private isMfaToggleInFlight = false;

  constructor(public mfaPreferencesService: MFAPreferencesService,
              public fb: UntypedFormBuilder,
              private configService: ConfigurationService,
              private localeService: LocaleService,
              public sharedService: SharedService,
              private sessionStorageService: SessionStorageService,
              private poprService: PoprService,
              private popr2Service: Popr2Service,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private gdlService: GdlService,
              private el: ElementRef,
              @Inject(DOCUMENT) private _document: any,
              private translateService: TranslateService) {
  }

  ngOnInit(): void {
    this.twoStepVerifyForm = this.fb.group({
      mfaOnLogin: false,
      deliveryChannelPreference: ''
    });

    this.textMsgDropdownControl = new UntypedFormControl();
    this.phoneCallDropdownControl = new UntypedFormControl();

    this.textDropdownConfig = {
      id: 'smsDropdown',
      label: 'smsDropdown-label',
      name: 'smsNumbersList'
    };

    this.phoneDropdownConfig = {
      id: 'callDropdown',
      label: 'callDropdown-label',
      name: 'callNumbersList'
    };

    window.scroll(0, 0);
    this.mfaPreferencesAPI();
  }

  fetchUserDetails(event?: any): void {
    // Read defensively: the shared apiResponse subject may hold a value without
    // `output` (transient/late empty emission), so never dereference blindly.
    const phoneNumberDetails: PhoneNumberDetails[] =
      this.sharedService.apiResponse?.output?.userProfile?.userProfileAddress?.contactAncillaryDetail?.phoneNumberDetails;
    this.countryCode = phoneNumberDetails?.[0]?.number?.countryCode ?? '';
    this.primaryPhoneNumber = phoneNumberDetails?.[0]?.number?.localNumber;
    if (event && event.isSuccess && event.secondaryNumberDetails && phoneNumberDetails?.[1]?.number) {
      phoneNumberDetails[1].number.countryCode = event.secondaryNumberDetails.secondaryPhoneCountryCode;
      phoneNumberDetails[1].number.localNumber = event.secondaryNumberDetails.secondaryPhoneNumber;

      this.secondaryPhoneNumber = event.secondaryNumberDetails.secondaryPhoneNumber;

      this.textMsgNumberSelected = `+${this.countryCode} ${this.primaryPhoneNumber}`;
      this.textMsgDropdownControl.setValue('PHONE');
      this.textMsgSelectedLabel = 'phoneNumber.primaryPhoneNumber';
      this.phoneCallNumberSelected = `+${this.countryCode} ${this.primaryPhoneNumber}`;
      this.phoneCallDropdownControl.setValue('PHONE');
      this.phoneCallSelectedLabel='phoneNumber.primaryPhoneNumber';
    }

    // Only react to emissions that actually carry `output`; a null or empty
    // (no-output) emission must not throw or overwrite the resolved phone code.
    this.sharedService.userInfoResponse$
      .pipe(
        filter(data => !!data?.output),
        takeUntil(this.destroy$)
      )
      .subscribe((data: APIResponse) => {
        const details: PhoneNumberDetails[] = data.output.userProfile?.userProfileAddress?.contactAncillaryDetail?.phoneNumberDetails;
        this.countryCode = details?.[0]?.number?.countryCode ?? '';
        this.phoneCode = `+${this.countryCode}`;
      });
  }

  mfaPreferencesAPI(): void {
    let queryParams = {};
    this.activatedRoute.queryParamMap
      .subscribe((params) => {
        queryParams = params;
      });

      this.mfaPreferencesService.getUserMFAPreferences(true).subscribe(
        (response) => {
          this.contactDetails = response.output.deliveryChannelPreferences;
          this.sharedService.mfaChannelsList = this.contactDetails;
          this.isTwoSVToggleLoading = false;
          this.fetchUserDetails();
          this.populateDefaultDeliveryValues(response);
          //B-676133, declaring at class level to get the state of value when Cancel button clicked on continue popup
          this.defaultMfaOnLogin = response.output.mfaOnLogin;
          this.isTwoFAEnabled= response.output.mfaOnLogin;
          this.hideDefaultverifyandTrustedDevice.emit(this.isTwoFAEnabled);
          this.sessionStorageService.setItem('mfaToggleStatus', this.defaultMfaOnLogin);
          this.sessionStorageService.setItem('deliveryChannelPreference', response.output.preferredDeliveryMethod);
          this.twoStepVerifyForm.patchValue({ mfaOnLogin: response.output.mfaOnLogin });
          response.output?.deliveryChannelPreferences.filter((channel: any) => channel.primaryDeliveryMethod === true)
          .map((item: any) => this.deliveryMethod = item.deliveryMethod);
        },
        (error) => {
          this.isAPIFailLoginScreen = true;
          // GDL will triggeers incase of server validation error
          this.gdlService.captureGdlErrorMessages(this.gdlServerType, error, this.gdlContextGetType);
        }
      );


  }


  populateDefaultDeliveryValues(response: MFAPreferencesResponse): void {
    this.defaultDeliveryMethod = this.contactDetails.filter(
      preference => preference.primaryDeliveryMethod
    );
    const preferredDeliveryMethod = response.output?.preferredDeliveryMethod ?? this.defaultDeliveryMethod[0]?.deliveryMethod ?? 'EMAIL';
    this.patchDeliveryChannelPreference(preferredDeliveryMethod);
    this.populateV3PhoneNumberValues();
  }

  patchDeliveryChannelPreference(preference: string): void {
    this.twoStepVerifyForm.patchValue({ deliveryChannelPreference: preference });
  }

  populateV3PhoneNumberValues(): void {
    const emailDetails = this.contactDetails.find(data => data.deliveryMethod === 'EMAIL');
    const emailValue = emailDetails?.deliveryMethods?.find((data: any) => data.type === 'PERSONALEMAIL')
      ?? { value: emailDetails?.value ?? '' };
    this.personalEmail = emailValue;

    const formatPhoneValue = (value: string): string => value ? (this.countryCode ? `+${this.countryCode} ${value}` : value) : '';
    const getPhoneValue = (channel: DeliveryChannelPreferences | undefined): string => {
      const methods = channel?.deliveryMethods ?? [];
      const method = methods.find((data: any) => data.type === 'PHONE')
        ?? methods.find((data: any) => data.type === 'MOBILE')
        ?? methods[0];

      return method?.value ?? channel?.value ?? '';
    };

    const callChannel = this.contactDetails.find(data => data.deliveryMethod === 'CALL');
    const textChannel = this.contactDetails.find(data => data.deliveryMethod === 'SMS');

    const callValue = getPhoneValue(callChannel) || getPhoneValue(textChannel);
    const textValue = getPhoneValue(textChannel) || getPhoneValue(callChannel);

    this.primaryPhoneNumber = callValue || textValue || '';
    this.phoneCallNumberSelected = formatPhoneValue(callValue);
    this.textMsgNumberSelected = formatPhoneValue(textValue);
  }

  termsAndConditionClick($event: any): void {
    this.termsAndConditionUrl = `https://${this.configService.select('env.host')}${this.configService.select('links.termsAndConditionsUrl')}`;
    this.localeService.interpolate(this.termsAndConditionUrl).then((value) => {
      this.termsAndConditionUrl = value;
      if ($event.target.className.indexOf('termsAndConditions') >= 0) {
        this.openUrl(this.termsAndConditionUrl);
      }
     });
  }
   contactInfoClick(event?: Event): void {
    if (event) {
      const target = event.target as Element | null;
      const contactInfoLink = target?.closest('a.contactInformation');
      if (!contactInfoLink) {
        return;
      }
    }
    if (!this.sharedService.isEditScreen) {
      this.sharedService.setSelectedRoute('contact');
      this.router.navigate(['/contact']);
    } else {
      this.contactlinckclicked = true;
      // B-676133,show continue popup in edit mode
      this.showPopUp = this.sharedService.isEditScreen;
      const maxWidth = 768;
      if (screen.width < maxWidth) {
        this.sharedService.isModalPopupOpen = true;
        this._document.body.style.overflow = 'hidden';
      }
    }
  }
  openUrl(url: string): void {
    WindowRef.nativeWindow.open(url, '_blank');
  }

  toggleMfaCheck(event: any): void {
    if (this.isMfaToggleInFlight) {
      return;
    }

    // B-676133, get the state of toggle button and save at class level variable
    if (event != null && event.target != null) {
      this.mfaFlag = (event.target as HTMLInputElement).checked;
      (event.target as HTMLInputElement).checked = !(event.target as HTMLInputElement).checked;
    }

    this.isMfaToggleInFlight = true;
    this.isTwoSVToggleLoading = this.mfaFlag;
    this.changeMFAOnLogin();
  }

  toastMessage2SV(message: string, poprLevel: Popr2Priority): void {
    this.popr2Service.createToast(message, {
      priority: poprLevel
    }).open();
  }

  changeMFAOnLogin(): void {
    this.isTwoStepVerification = true;
    // B-676133,identify button click, so that repective method can be called while continuing on popup
    this.twoStepVerificationClicked = true;
    // B-676133,show continue popup in edit mode
    this.showPopUp = this.sharedService.isEditScreen;

    if (!this.sharedService.isEditScreen) {
      this.updateMfaOnLogin();
    } else {
      const maxWidth = 768;
      if (screen.width < maxWidth) {
        this.sharedService.isModalPopupOpen = true;
        this._document.body.style.overflow = 'hidden';
      }
    }
  }

  updateMfaOnLogin(): void {
    let queryParams = {};
    this.activatedRoute.queryParamMap
      .subscribe((params) => {
        queryParams = params;
      });

      this.mfaPreferencesService.updateMFAOnLogin(this.mfaFlag, queryParams).pipe(
      ).subscribe(() => {
      this.isMfaToggleInFlight = false;
      this.isTwoSVToggleLoading = false;
      this.twoStepVerifyForm.patchValue({ mfaOnLogin: this.mfaFlag });
      let successMsg;
      const messageKey = this.mfaFlag ? 'successNotification.twoSVSuccessDescription': 'successNotification.twoSVDisableDescription';
      this.translateService.get(messageKey).subscribe((translatedMsg) => {
        successMsg = translatedMsg;
      });
      this.toastMessage2SV(successMsg, Popr2Level.SUCCESS);
      // this.sharedService.isMfaPreferenceEnabled = this.mfaFlag;
      this.sessionStorageService.setItem('mfaToggleStatus', this.mfaFlag);
      this.isTwoStepVerification = false;
      this.isTwoFAEnabled=this.mfaFlag;
      this.hideDefaultverifyandTrustedDevice.emit(this.mfaFlag);
      const mfaLogin = this.twoStepVerifyForm.controls['mfaOnLogin'].value ? this.gdlMfaSwitchOn : this.gdlMfaSwitchOff;
      this.gdlService.captureInteractionEvent(this.gdlMfaLogin, mfaLogin);
      this.patchDeliveryChannelPreference(this.deliveryMethod);
    }, (httpError) => {
      this.isMfaToggleInFlight = false;
      this.twoStepVerifyForm.patchValue({ mfaOnLogin: !this.mfaFlag });
      this.handleError(httpError, '2stepVerification');
      // GDL will triggeers incase of server validation error
      this.gdlService.captureGdlErrorMessages(this.gdlServerType, httpError, this.gdlContextPutType);
    });
  }

  changeMFAPrefrenceType(deliveryType: string): void {
    // B-676133,show continue popup in edit mode
    this.showPopUp = this.sharedService.isEditScreen;
    // B-676133,set delivery type, so that same can be passed while continuing on popup
    this.deliveryType = deliveryType;
    if (!this.sharedService.isEditScreen) {
      this.mfaPreferencesService.updateUserMFAPreferences(deliveryType).subscribe(
        () => {
          this.gdlService.captureInteractionEvent('verification', deliveryType);
          this.hideSuccessNotificationPopup.emit(true);
          this.sessionStorageService.setItem('deliveryChannelPreference', this.deliveryType);
          this.patchDeliveryChannelPreference(this.deliveryType);
          this.deliveryMethod = deliveryType;
        }, (httpError) => {
          this.handleError(httpError, 'deliveryPreference');
          // GDL will triggeers incase of server validation error.
          this.gdlService.captureGdlErrorMessages(this.gdlServerType, httpError, this.gdlContextPutType);
          this.deliveryTypeOld = (this.sessionStorageService.getItem('deliveryChannelPreference')).toString();
          this.patchDeliveryChannelPreference(this.deliveryTypeOld);
        });
    } else {
      const maxWidth = 768;
      if (screen.width < maxWidth) {
        this.sharedService.isModalPopupOpen = true;
        this._document.body.style.overflow = 'hidden';
      }
      this.deliveryTypeOld = (this.sessionStorageService.getItem('deliveryChannelPreference')).toString();
      this.patchDeliveryChannelPreference(this.deliveryTypeOld);
    }
  }

  //B-999556 update secondry phone number prefecence for MFA

  handleError(err: HttpErrorResponse, messageFlag: string): void {
    const obj = { flag: true, messageFlag };

    const errorCodes = (err?.error?.errors) ? err?.error?.errors[0].code.toLowerCase().replaceAll('.', '_') : '';

    if (err.status === this.ERROR_CODE_400 && err.error.errors && errorCodes === 'stepup_auth_expired')
    {
      if (this.isMfaToggleInFlight) {
        this.hideNotificationPopup.emit(obj);
        return;
      }

      this.elevateAuthority$().subscribe((isElevated) => {
        if (isElevated && this.isTwoStepVerification) this.toggleMfaCheck(null);
        else this.poprService.createToast(PoprPriority.ERROR, this.twoFactorFailureTemplate);
      });
    }
    else {
      this.hideNotificationPopup.emit(obj);
    }
  }

  //B-676133, hide continue poup and reset values to have page on initial state.
  hidePopup(event: boolean): void {
    this.showPopUp = event;
    if (this.twoStepVerificationClicked) {
      this.twoStepVerifyForm.patchValue({ mfaOnLogin: !this.mfaFlag });
      this.isTwoSVToggleLoading = false;
    }
    this.twoStepVerifyForm.patchValue({ deliveryChannelPreference: this.defaultDeliveryMethod[0].deliveryMethod });
    this.twoStepVerificationClicked = false;
    this.deliveryType = '';
    const maxWidth = 768;
    if (screen.width < maxWidth) {
      this.sharedService.isModalPopupOpen = false;
      this._document.body.style.overflow = 'auto';
    }
  }

  //B-676133, trigger event when continue clicked, and sense button click and call methods accordingly for
  //further processing.
  continue(): void {
    this.closeLoginEdit.emit(false);
    if (this.twoStepVerificationClicked) {
      this.toggleMfaCheck(null);
    } else if (this.contactlinckclicked) {
      this.sharedService.setSelectedRoute('contact');
      this.router.navigate(['/contact']);
    }
    else {
      this.changeMFAPrefrenceType(this.deliveryType);
    }
  }

  /**
   * Elevate user's authority to allow save/update to proceed
   *
   * @return true if user authority elevated, false otherwise
   */
  elevateAuthority$(): Observable<boolean> {
    const modal = this.poprService.createModal(TwoFactorComponent);
    return modal.component$().pipe(
      switchMap(comp => comp.isElevatedAuthority$()),
      defaultIfEmpty(false),
      finalize(() => modal.close())
    );
  }

  ngAfterViewInit(): void {
    if (this.twosvFlag) {
      const headerOffset = 63; //shf header
      const elementToFocus = this.el.nativeElement.querySelector('[id=\'check5.1\']');
      const elementToScroll = this.el.nativeElement.querySelector('[id=\'verification-title\']');
      const currElemRect = elementToScroll?.getBoundingClientRect();
      const currentElemPosition = window.scrollY + currElemRect?.top;
      const scrollY = currentElemPosition - headerOffset;
      setTimeout(() => {
        window.scrollTo(0, scrollY);
        elementToFocus?.focus();
      }, 1000);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}

